export default __webpack_public_path__ + "assets/2b57c297e5acda32670397ea70fa132b.jpg";